import type { FC } from 'react';

import { NextImage } from '@/components/NextImage';

import * as S from './RetailerHeader.styles';

interface RetailerHeaderProps {
  bannerImage: string;
  logoImage: string;
}

export const RetailerHeader: FC<RetailerHeaderProps> = ({
  bannerImage,
  logoImage,
}) => {
  return (
    <S.HeaderContainer>
      <S.BannerImage $backgroundImage={bannerImage} />
      <S.LogoContainer>
        <NextImage
          alt='Breitling Logo'
          height={80}
          loading='eager'
          src={logoImage}
          width={170}
        />
      </S.LogoContainer>
    </S.HeaderContainer>
  );
};
